// @ts-nocheck
import React, { useState, useEffect, FC } from "react";
import {useRecoilValue, useSetRecoilState} from "recoil";
import { whichAuth as getAuth } from "../../getAuth";
import {userState} from "../../atoms";
import {IonButton, IonCol, IonIcon, IonRow, IonSpinner} from "@ionic/react";
import {lockClosed, pencil} from "ionicons/icons";
import {AlertModal} from "../index";
import {CreditCardFormProps} from "./CreditCardForm.model";
import {CardElement, useElements, useStripe} from '@stripe/react-stripe-js';
import { handleErrors } from '../../utils/handleErrors';

const CreditCardForm: FC<CreditCardFormProps> = ({ onClose }) => {

  const user = useRecoilValue(userState);
  const setUser = useSetRecoilState(userState);
  const [creditCardDetails, setCreditCardDetails] = useState<string>('');
  const [editingCC, setEditingCC] = useState<boolean>(!user?.hasPaymentMethod);
  const [paymentInProgress, setPaymentInProgress] = useState<boolean>(false);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [modalMessage, setModalMessage] = useState<string>('');
  const [modalTitle, setModalTitle] = useState<string>('');
  const [closeAlertModal, setCloseAlertModal] = useState<boolean>(false)

  const stripe = useStripe();
  const elements = useElements();
  
  const submitCardDetails = () => {
    setPaymentInProgress(true);
    
    stripe.createPaymentMethod({
      type: 'card',
      card: elements.getElement(CardElement),
    })
    .then(paymentMethod => {
      if(paymentMethod.error) {
        throw paymentMethod.error.message;
      }
      return getAuth().currentUser.getIdToken().then(token => {
        return fetch(user._links.self.href + '/paymentMethod', {
          method: 'POST',
          headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({id:paymentMethod?.paymentMethod?.id})
        })
        .then(response => {
          if(response.status === 201) {
            return response.text().then(hasPaymentMethod => hasPaymentMethod);
          } else { // error
            return response.text().then(error => {
              try {
                error = JSON.parse(error);
                error = JSON.parse(error.message).error.message;
              } finally { throw error; }
            });
          }
        })
      })
    })
    .then(hasPaymentMethod => {
      setUser({...user, hasPaymentMethod});
      setModalTitle("Payment details updated");
      setModalMessage("Thank you for adding your payment details.");
      setIsOpenModal(true);
      setCloseAlertModal(true);
      getCreditCardDetails();
    })
    .catch(error => {
      setCloseAlertModal(false);
      setModalTitle("Failed to add credit card.");
      setModalMessage(error);
      setIsOpenModal(true);
    })
    .finally(() => setPaymentInProgress(false));
  }
  
  const getCreditCardDetails = () => getAuth().currentUser.getIdToken().then(token =>
    fetch(user._links.self.href + '/creditCardDetails', {headers: {'Authorization': 'Bearer ' + token}})
      .then(handleErrors)
      .then(details => setCreditCardDetails(details))
      .catch(() => setCreditCardDetails('')));
  
  useEffect(getCreditCardDetails, [user?.hasPaymentMethod]);

  return (
      <div>
        { !editingCC ?
          <IonRow className="settings-row-buttons" >
            <IonCol className="settings-col first">
              <IonButton className="settings-content-button" onClick={() => setEditingCC(true)}>
                &nbsp;&nbsp;{creditCardDetails || "Update credit card"}&nbsp;&nbsp;<IonIcon icon={pencil} />&nbsp;
              </IonButton>
            </IonCol>
          </IonRow>
          :
          <>
            <div className="iframe-card">
              <CardElement options={{
                style: {
                  base: {
                    color: '#26468B',
                    backgroundColor: '#FFFFFF',
                    fontSize: '1.05em',
                    fontWeight: '600',
                    fontSmoothing: 'antialiased',
                    ':-webkit-autofill': {
                      color: '#26468B',
                    },
                    '::placeholder': {
                      color: '#a7b4d0',
                    },
                  },
                }}} />
            </div>
            
            <IonRow className="settings-row-buttons" >
              <IonCol className="settings-col first">
                <IonButton
                  onClick={submitCardDetails}
                  className="settings-content-button"
                  disabled={paymentInProgress}
                  type="button">
                    {paymentInProgress ? <IonSpinner name="dots" /> : <IonIcon icon={lockClosed} />}&nbsp;
                    { user.hasPaymentMethod ? 'Update' : 'Save' }
                </IonButton>
              </IonCol>
              <IonCol className="settings-col last">
                <IonButton className="settings-content-button cancel" 
                  onClick={() => {
                    elements.getElement(CardElement).clear();
                    setEditingCC(false);
                    onClose && onClose();
                  }}>
                  Close
                </IonButton>
              </IonCol>
            </IonRow>
            </>
        }
        
      
        <AlertModal
          isOpen={isOpenModal}
          title={modalTitle}
          subTitle={modalMessage}
          onClosed={() => {
            setIsOpenModal(false)
            if (closeAlertModal) {
              onClose?.()
            }
          }}
        />
      </div>
  )
}

export default CreditCardForm
